import { inject, Injectable } from '@angular/core';
import {
  RsOverviewServerSideStateManager
} from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import { ArchivedInvoiceItemResponse, GetArchivedInvoicesRequestParams, InvoicesService } from '@api-client/mobipay';
import { DEFAULT_PAGE_SIZE_OPTIONS } from '@app/shared/constants';


@Injectable({ providedIn: 'root' })
export class ArchiveInvoicesStateService extends RsOverviewServerSideStateManager<
  ArchivedInvoiceItemResponse,
  GetArchivedInvoicesRequestParams
> {
  private readonly invoicesService = inject(InvoicesService);
  constructor() {
    super({
      serviceMethod: (params) =>
        this.invoicesService.getArchivedInvoices(params as GetArchivedInvoicesRequestParams, 'response'),
      initialPagination: { pageIndex: 0, pageSize: 15 },
      config: {
        pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
      },
      disableRxResource: true,
    });
  }
}

